import React from 'react';
import IconReset from '../icons/IconReset';
import { useColorPickerContext } from './context';

interface Props {
  defaultColor: string;
}

function Reset({ defaultColor }: Props) {
  const { onChange } = useColorPickerContext();
  return (
    <IconReset className="ml-auto" onClick={() => onChange(defaultColor)} />
  );
}

export default Reset;
